// Module
var code = "<div ng-if=\"$ctrl.identifiers.length === 1\"> {{::$ctrl.identifiers[0].code}} </div> <div ng-repeat=\"identifier in $ctrl.identifiers track by identifier.code\" ng-if=\"$ctrl.identifiers.length > 1\"> <label>{{::$ctrl.identifierTypes[identifier.identifierType].label}}</label>:&nbsp;{{::identifier.code}} </div> ";
// Exports
var _module_exports =code;;
var path = 'components/itemIdentifiers/itemIdentifiers.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;